/* src/components/FacturasView.jsx */
import React from "react";

export default function FacturasView(props) {
  return (
    <div style={{ padding: 30, textAlign: "center", fontSize: 18 }}>
      <p>Contenido de la sección <strong>Facturas</strong> por definirse...</p>
    </div>
  );
}
